(function() {
/*
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
  });
  
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  
  let colorSwatchesButtons = document.querySelectorAll('.swatch__button-color');
  if (colorSwatchesButtons) {
    colorSwatchesButtons.forEach((btn) => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        console.log(1);
        window.location.href = this.href;
      }, false);
    });
  }*/

  function targetBlank() {
    // remove subdomain of current site's url and setup regex
    let internal = location.host.replace("www.", "");
        internal = new RegExp(internal, "i");
        
    const a = document.querySelectorAll(".theme__header .header__menu a"); // then, grab every link in header
    for (let i = 0; i < a.length; i++) {
      const href = a[i].host; // set the host of each link
      if( !internal.test(href) ) { // make sure the href doesn't contain current site's host
        a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
      }
    }
  };

  targetBlank();
})();
